import { BabylonjsModule } from '@modules/babylonjs/src/BabylonjsModule';
import { useZed } from '@modules/core/src/react/useZed';
import { StandardModule } from '@modules/standard/src/StandardModule';
import * as dateFns from 'date-fns';
import { useCallback, useEffect, useState } from 'react';

import { SunPositionGuiResponse } from '../ecs/component/response/Sun';
import { TourDanjiModule } from '../TourDanjiModule';

import sunIcon from './assets/sun_icon.png';
import { GUIView } from './GUIUtiles';
import styles from './styles/SunPositionView.module.css';

export function SunPositionView({}: {}) {
  const zed = useZed<[BabylonjsModule, StandardModule, TourDanjiModule]>();
  const [sunPositionGUIs, setSunPositionGUIs] = useState<SunPositionGuiResponse[]>([]);
  const [svgPath, setSvgPath] = useState<string>();

  const updateSunPositions = useCallback(
    (data: SunPositionGuiResponse[]) => {
      if (JSON.stringify(sunPositionGUIs) === JSON.stringify(data)) return;
      setSunPositionGUIs(data);
    },
    [sunPositionGUIs]
  );

  useEffect(() => {
    if (!zed) return;

    const observer = zed.api.observer.onUpdateSunPositionGUI.add(updateSunPositions);

    return () => {
      observer?.remove();
    };
  }, [zed, updateSunPositions]);

  useEffect(() => {
    const [first, ...rest] = sunPositionGUIs.filter((item) => item.isVisible);
    setSvgPath(
      first &&
        rest.reduce((acc, item) => (item.isVisible ? `${acc}L${item.x},${item.y}` : acc), `M${first.x},${first.y}`)
    );
  }, [sunPositionGUIs]);

  return (
    <GUIView>
      <svg className={styles.sunPosition}>
        {svgPath && <path className={styles.sunPath} d={svgPath} />}
        {sunPositionGUIs.map(
          (item) =>
            item.isVisible && (
              <g className={styles.sunLabel} key={item.key} transform={`translate(${item.x},${item.y})`}>
                <image href={sunIcon} />
                <text>{dateFns.format(item.object.date, 'a hh:mm')}</text>
              </g>
            )
        )}
      </svg>
    </GUIView>
  );
}
